module.exports = __webpack_public_path__ + "9d049d624426d82c364e551e3c736cfe.svg";